<!-- This is a copy of the SweetAlert2 alert HTML -->
<!-- The package was removed so we now maintain our own version of if -->
<template>
    <div v-show="show"
         @click="close()"
         class="swal2-container swal2-center swal2-fade swal2-shown"
         style="overflow-y: auto;"
    >
        <!-- We use @click.stop to prevent a click from propagating to the parent click handler -->
        <div @click.stop=""
             role="dialog"
             aria-modal="true"
             aria-labelledby="swal2-title"
             aria-describedby="swal2-content"
             class="swal2-modal swal2-show"
             tabindex="-1"
             style="width: 500px; padding: 20px; background: rgb(255, 255, 255); display: block;"
        >
            <!-- Error icon -->
            <div v-if="type === 'error'"
                 class="swal2-icon swal2-error swal2-animate-error-icon"
            >
                <span class="swal2-x-mark swal2-animate-x-mark">
                    <span class="swal2-x-mark-line-left"></span>
                    <span class="swal2-x-mark-line-right"></span>
                </span>
            </div>

            <!-- Question icon -->
            <div v-if="type === 'question'" class="swal2-icon swal2-question">?</div>

            <!-- Warning icon -->
            <div v-if="type === 'warning'" class="swal2-icon swal2-warning">!</div>

            <!-- Info icon -->
            <div v-if="type === 'info'" class="swal2-icon swal2-info">i</div>

            <!-- Success icon -->
            <div v-if="type === 'success'"
                 class="swal2-icon swal2-success swal2-animate-success-icon"
            >
                <div class="swal2-success-circular-line-left" style="background: rgb(255, 255, 255);"></div>
                <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
                <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
                <div class="swal2-success-ring"></div>
                <div class="swal2-success-fix" style="background: rgb(255, 255, 255);"></div>
                <div class="swal2-success-circular-line-right" style="background: rgb(255, 255, 255);"></div>
            </div>

            <h2 class="swal2-title" id="swal2-title">{{ title }}</h2>
            <div id="swal2-content" class="swal2-content" style="display: block;">{{ text }}</div>
            <div v-if="showConfirmButton || showCancelButton"
                 class="swal2-buttonswrapper"
                 style="display: flex;justify-content: center;"
                 :style="{flexDirection: reverseButtons ? 'row-reverse' : 'row'}"
            >
                <button v-if="showConfirmButton"
                        @click="onConfirm"
                        type="button"
                        class="swal2-confirm"
                        :class="[confirmButtonClass, {'swal2-styled' : buttonsStyling}]"
                        aria-label=""
                        :style="{
                            backgroundColor: buttonsStyling ? '#3085d6' : '',
                            borderRightColor: buttonsStyling ? '#3085d6' : '',
                            borderLeftColor: buttonsStyling ? '#3085d6' : '',
                        }"
                >
                    {{ confirmButtonText }}
                </button>
                <button v-if="showCancelButton"
                        @click="onCancel"
                        type="button"
                        class="swal2-cancel"
                        :class="[cancelButtonClass, {'swal2-styled' : buttonsStyling}]"
                        aria-label=""
                        style="display: inline-block;"
                        :style="{
                            backgroundColor: buttonsStyling ? '#aaa' : '',
                            borderRightColor: buttonsStyling ? '#aaa' : '',
                            borderLeftColor: buttonsStyling ? '#aaa' : '',
                        }"
                >
                    {{ cancelButtonText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Alert.vue",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                validator: function(value) {
                    return ['success', 'warning', 'info', 'question', 'error'].includes(value);
                }
            },
            title: {
                type: String,
                required: true
            },
            text: {
                type: String,
                default: ''
            },
            allowOutsideClick: {
                type: Boolean,
                default: true
            },
            showConfirmButton: {
                type: Boolean,
                default: true
            },
            showCancelButton: {
                type: Boolean,
                default: false,
            },
            confirmButtonText: {
                type: String,
                default: 'OK'
            },
            confirmButtonClass: {
                type: String,
                default: ''
            },
            cancelButtonText: {
                type: String,
                default: 'Cancel'
            },
            cancelButtonClass: {
                type: String,
                default: ''
            },
            buttonsStyling: {
                type: Boolean,
                default: true
            },
            reverseButtons: {
                type: Boolean,
                default: false
            },
            onConfirm: {
                type: Function,
                default: () => {}
            },
            onCancel: {
                type: Function,
                default: () => {}
            },
        },
        methods: {
            close() {
                if (this.allowOutsideClick) {
                    if (this.type === 'warning') {
                        this.onCancel();
                    } else {
                        this.onConfirm();
                    }
                }
            },
        }
    }
</script>
